export default (theme) => ({
    root: {
        height: '100%',
        width: '100%',
        position: 'relative',
    },
    childrenRoot: {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
    },
    shown: {
        opacity: '1 !important',
    },
    withFade: {
        height: '100%',
        width: '100%',
    },
    topFade: {
        content: '',
        position: 'absolute',
        top: 0,
        left: 0,
        right: '8px',
        height: '30px',
        background: `linear-gradient(to bottom,
                rgba(255, 255, 255, 1) 10%,
                rgba(255, 255, 255, 0.7) 30%,
                rgba(255, 255, 255, 0) 100%,
            )`,
    },
    bottomFade: {
        content: '',
        position: 'absolute',
        top: 0,
        left: 0,
        right: '8px',
        height: '30px',
        background: `linear-gradient(to bottom,
                rgba(255, 255, 255, 1) 10%,
                rgba(255, 255, 255, 0.7) 30%,
                rgba(255, 255, 255, 0) 100%,
            )`,
    },
    showVerticalOnHover: {
        '&:hover > div:last-child': {
            opacity: '1 !important',
        },
    },
    scrollContainer: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        height: '100%',
        width: 'auto !important',
        transform: 'none !important',
        /* Full-size positioning for child alignment; do not steal clicks from filter controls */
        pointerEvents: 'none',
    },
    scrollButton: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        width: '60px',
        zIndex: 4,
        pointerEvents: 'auto',

        '& svg': {
            flexShrink: 0,
            height: '18px',
            width: '18px',

            '& path': {
                fill: theme.colors.actionMinor[500],
            },
        },
    },
    buttonRight: {
        background: `linear-gradient(to right, rgba(255, 255, 255, 0), ${theme.colors.primary.white})`,
        right: 0,
        cursor: 'pointer',
        justifyContent: 'flex-end',
        paddingRight: 2,

        '& svg': {
            marginRight: -2,
        },
    },
    buttonLeft: {
        background: `linear-gradient(to left, rgba(255, 255, 255, 0), ${theme.colors.primary.white})`,
        left: 0,
        cursor: 'pointer',
        justifyContent: 'flex-start',
        paddingLeft: 2,

        '& svg': {
            marginLeft: 2,
        },
    },
});
